import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EncodingUtils } from '../encoding-utils';

@Injectable()
export class EncodingInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let body: any;

    if (req.headers.has('Content-Type')) {
      body = req.body;
    } else {
      body = EncodingUtils.encodeRequest(req.body);
    }

    let { headers } = req;
    // we want browser to determin content type
    headers = headers.delete('Content-Type');

    const newRequest = req.clone({
      headers,
      body,
      params: this.encodeParams(req.params),
      url: this.constructUrl(req),
    });

    return next.handle(newRequest).pipe(
      map((event: HttpEvent<any>) => {
        if (newRequest.url.indexOf('promotion/download') > 0 || newRequest.url.indexOf('download') > 0) {
          return event;
        }
        return this.tryToDecodeHttpResponseBody(event);
      })
    );
  }

  private constructUrl(req: HttpRequest<any>): string {
    if (
      req.url.startsWith('http') ||
      req.url.indexOf('/admin/config.json') !== -1 ||
      req.url.indexOf('/player-activity/') !== -1 ||
      req.url.indexOf('/player/api') !== -1 ||
      req.url.indexOf('/content/') !== -1 ||
      req.url.indexOf('/promotions/') !== -1 ||
      req.url.indexOf('/free-to-play-games/') !== -1 ||
      req.url.indexOf('/ordermanager/') !== -1 ||
      req.url.indexOf('/lottos/') !== -1 ||
      req.url.indexOf('/jackpots/') !== -1 ||
      req.url.indexOf('/payments/api/') !== -1 ||
      req.url.indexOf('/free-to-play-games/api/') !== -1 ||
      req.url.indexOf('/search/') !== -1 ||
      req.url.indexOf('/aml-case/api') !== -1 ||
      req.url.indexOf('/crm/api') !== -1
    ) {
      return req.url;
    } else {
      return '/admin/rest' + req.url;
    }
  }

  private tryToDecodeHttpResponseBody(event: HttpEvent<any>) {
    return event instanceof HttpResponse ? event.clone({ body: EncodingUtils.decodeResponse(event.body) }) : event;
  }

  private encodeParams(params: HttpParams): HttpParams {
    let newParams = new HttpParams();

    params.keys().forEach((key) => {
      const val = params.get(key);
      const encodedKey = EncodingUtils.encodeRequest(key);
      newParams = newParams.append(encodedKey, val);
    });

    return newParams;
  }
}
